import { Splide } from '@splidejs/splide';
import { initCustomSelects } from '../helpers/custom-select';

document.addEventListener('DOMContentLoaded', () => {
    initCustomSelects();
});


// js-hero-card

document.querySelectorAll('.js-hero-card').forEach(trigger => {
    trigger.addEventListener('click', () => {
        // climb up to the .hero-card wrapper
        const heroCard = trigger.closest('.hero-card');
        // grab the .hero-card__wrapper inside that card
        const wrapper  = heroCard.querySelector('.hero-card__wrapper');
        // toggle the expanded class

        trigger.classList.toggle('expanded');
        wrapper.classList.toggle('expanded');
    });
});

if (document.querySelector('.js-game-hero-slider')) {
    new Splide('.js-game-hero-slider', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: {
            prev: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            next: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        },
        gap: '1.5rem',
        pagination: false,
        padding: {right: '10%', left: '10%'},
    }).mount();
}
